<template>
  <v-autocomplete
    v-if="!$apollo.loading"
    :items="power_plants"
    item-text="name"
    prepend-icon="flash_on"
    label="Planta"
    :v-model="power_plant || {}"
    return-object
    :rules="[(v) => !!v || 'Selecione a Planta que desejada']"
  ></v-autocomplete>
</template>

<script>
import { GET_POWERPLANTCOMBO } from "../../graphql/powerplants";

export default {
  // props: ['power_plants','power_plant'],
  data: () => ({
    power_plants: [],
    power_plant: {},
  }),
  apollo: {
    powerplants: {
      query: GET_POWERPLANTCOMBO,
      // Optional result hook
      result({ data, loading }) {
        this.power_plants = data.powerplants;
        this.loading = loading;
      },
      // Error handling
      error(error) {
        console.error("We've got an error!", error);
      },
    },
  },
};
</script>
